<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';
import { MonitorUp } from 'lucide-vue-next';
import OrderTracker from '../components/orders/OrderTracker.vue';
import { useOrdersStore } from '../stores/orders-store';
import { useSessionStore } from '../stores/session-store';

const ordersStore = useOrdersStore();
const sessionStore = useSessionStore();

onMounted(() => {
  if (sessionStore.sessionId) {
    ordersStore.startPolling(sessionStore.sessionId);
  }
});

onBeforeUnmount(() => {
  ordersStore.stopPolling();
});
</script>

<template>
  <section class="display-client-screen" data-client-screen="display" data-testid="client-display-screen">
    <a href="#main" class="skip-link">Saltar al contenido principal</a>
    <header class="display-client-screen__header">
      <MonitorUp :size="34" />
      <div>
        <span>Solo lectura</span>
        <h1>Estado de órdenes</h1>
      </div>
    </header>

    <main id="main" tabindex="-1" class="display-client-screen__board">
      <OrderTracker readonly active-order-id="" />
    </main>
  </section>
</template>

<style scoped>
.display-client-screen {
  min-height: 100vh;
  color: #f8fafc;
  background:
    radial-gradient(1100px 480px at 10% -10%, rgba(34, 211, 238, 0.12), transparent 60%),
    linear-gradient(180deg, #0b1120 0%, #0f172a 100%);
}

.display-client-screen__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.45rem 2rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(17, 24, 39, 0.88);
  backdrop-filter: blur(8px);
}

.display-client-screen__header span {
  color: #67e8f9;
  font-size: 0.88rem;
  font-weight: 900;
  text-transform: uppercase;
}

.display-client-screen__header h1 {
  margin: 0.15rem 0 0;
  font-size: clamp(2rem, 4vw, 4.2rem);
  line-height: 1;
}

.display-client-screen__board {
  width: min(1280px, calc(100vw - 3rem));
  margin: 0 auto;
  padding: 2rem 0 2.4rem;
}

:deep(.order-tracker h2) {
  color: #f8fafc;
  font-size: 2rem;
}

:deep(.order-card) {
  border-color: rgba(103, 232, 249, 0.28);
  background: linear-gradient(180deg, rgba(23, 32, 51, 0.96), rgba(15, 23, 42, 0.96));
  box-shadow: 0 14px 30px rgba(2, 6, 23, 0.32);
}

:deep(.order-header h3),
:deep(.item-name),
:deep(.order-total) {
  color: #f8fafc;
}

:deep(.item-quantity),
:deep(.no-orders),
:deep(.loading) {
  color: #cbd5e1;
}
</style>
